
<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from "vue-multiselect";
import config from "../../config";
import { error_message, success_message, get_user } from "../../Helper/helper";
import { routes } from "../../config/api_routes";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import {
  required,
  email,
  numeric,
  helpers,
  requiredIf,
} from "vuelidate/lib/validators";
import {
  vendorService,
  deliveryZoneService,
  settingService,
  userService,
} from "../../services";
const floating = helpers.regex("floating", /^(?:\d*\.\d{1,2}|\d+)$/);

/**
 * update-profile component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Multiselect,
    DropzonePopup,
    VueGoogleAutocomplete,
  },
  props: ["rest_data"],
  data() {
    return {
      title: this.trans.get("__JSON__.Profile"),
      config: config,
      filename: "",
      restaurant_id: "",
      url: null,
      search: "",
      isLoading: false,
      countries: [],
      states: [],
      cities: [],
      center: { lat: 0.0, lng: 0.0 },
      marker: null,
      vendor_currency: "",
      country: "",
      state: "",
      city: "",
      country_count: "",
      state_count: "",
      city_count: "",
      disable: false,
      restaurant: {
        name: "",
        email: "",
        phone: "",
        country: "",
        state: "",
        city: "",
        address: "",
        location_address: "",
        minimum_order_value: "",
        delivery_type_time_slots: "",
        currency: "",
        restaurant_tax: "",
        image: "",
        payment_option: "",
        name_thai: ""
      },
      icon_image: "",
      icon_image_path: "",
      restaurant_media_path: "",
      icon_image_delete_url: routes.vendorImageDeleteUrl,
      restaurant_id: "",
      defaultcountry: "",
      defaultstate: "",
      defaultcity: "",
    };
  },
  validations: {
    restaurant: {
      name: {
        required,
      },
      name_thai: {
        required
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
      },
      country: {
        required,
      },
      city: {
        required,
      },
      state: {
        required,
      },
      address: {
        required,
      },
      address_thai: {
        required
      },
      location_address: {
        required,
      },
      minimum_order_value: {
        required,
        floating,
      },
      image: {
        required: requiredIf(function (nestedModel) {
          return !(!!this.icon_image || !!this.restaurant.image);
        }),
      }
    },
  },
  mounted() {
    this.initMap();
    this.getRestaurantById();
    this.$refs.address.focus();
    this.getSetting();
    this.vendor_id = get_user().vendor_id || 40818;
  },
  methods: {
    initMap() {
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 8,
      });
    },
    floatingNumber(e){   
      const floating = /^[0-9.]\d*(\.\d{1,2})?$/;
      let char = String.fromCharCode(e.keyCode);
      if (floating.test(char)) return true;
      else e.preventDefault();
    },
    isLetterOrNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    onIconImagedeleted(value) {
      this.icon_image = "";
    },
    userCheckEmail(e) {
      userService
        .userCheckEmail({
          email: this.restaurant.email,
          id: this.restaurant.user_id,
          table: "User",
          column: "user_id",
          vendor_id: this.vendor_id,
          user_role: "2",
        })
        .then((response) => {
          if (response.data.code === 101) {
            this.disable = true;
            error_message(response.data.message);
          } else {
            this.disable = false;
          }
        });
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData;
      this.restaurant.address = placeResultData.formatted_address;
      this.restaurant.latitude = addressData.latitude;
      this.restaurant.longitude = addressData.longitude;
      if (this.marker) {
        this.marker.setMap(null);
      }
      const marker = {
        lat: addressData.latitude,
        lng: addressData.longitude,
      };
      const latlng = new google.maps.LatLng(
        addressData.latitude,
        addressData.longitude
      );
      this.marker = new google.maps.Marker({
        position: latlng,
        title: "Restaurant",
      });
      this.marker.setMap(this.map);
      this.map.setCenter(latlng);
      this.center = marker;
      this.map.setZoom(14);
    },
    getSetting() {
      settingService.getSetting().then((response) => {
        this.vendor_currency = response.data.result.currency;
      });
    },
    getRestaurantById() {
      if (this.rest_data) {
        this.getData(this.rest_data);
      } else {
        vendorService
          .getRestaurantById({
            restaurant_id: this.$route.params.restaurant_id,
          })
          .then((response) => {
            this.getData(response.data.result);
          });
      }
    },
    getData(rest_data) {
      this.restaurant_media_path = rest_data.restaurant_media_path;
      this.icon_image_path = rest_data.icon_image_path;
      this.icon_image = rest_data.icon_image;
      this.restaurant_id = rest_data.restaurant_id;
      this.user_id = rest_data.user_id;
      this.restaurant = {
        ...rest_data,
      };
      const cent = {
        lat: parseFloat(rest_data.latitude),
        lng: parseFloat(rest_data.longitude),
      };
      this.country = rest_data.country;
      this.state = rest_data.state;
      this.city = rest_data.city;

      this.center = cent;

      const latlng = new google.maps.LatLng(
        rest_data.latitude,
        rest_data.longitude
      );
      this.marker = new google.maps.Marker({
        position: latlng,
        title: "Restaurant",
      });

      this.marker.setMap(this.map);
      this.map.setCenter(latlng);

      this.defaultcountry = this.restaurant.country;
      this.defaultstate = this.restaurant.state;
      this.defaultcity = this.restaurant.city;
      this.getVendorCountry();
    },
     getVendorCountry() {
      // this.restaurant.state = '';
      // this.restaurant.city = '';
      this.states = [];
      this.cities = [];
      deliveryZoneService.getVendorCountry().then((response) => {
        this.country_count = response.data.result.length;
        this.countries = response.data.result;
        if (this.country_count == 1) {
          this.restaurant.country = this.countries[0].id;
          this.getVendorState();
        } else if (this.country_count > 0) {
          if (this.restaurant.country > 0) {
            this.getVendorState();
          }
        }
      });
    },
    getVendorState() {
      this.states = [];
      this.cities = [];
      this.city_count = 0;
      this.state_count = 0;
      // this.restaurant.city = '';
      // this.restaurant.state = '';
      if(!this.restaurant.country) return false;
      deliveryZoneService.getVendorState({country_id: this.restaurant.country}).then((response) => {
        this.state_count = response.data.result.length;
        this.states = response.data.result.sort((a, b) => {
          return a.state_name.localeCompare(b.state_name);
        });
        this.states = response.data.result;
        if (this.defaultcountry === this.restaurant.country && this.state_count > 0) {
          this.restaurant.state = this.defaultstate;
        }
        if (this.state_count == 1) {
          this.restaurant.state = this.states[0].id;
          this.getVendorCity();
        } else {
          if (this.defaultcountry === this.restaurant.country && this.state_count > 0) {
            if (this.restaurant.state > 0) {
              this.getVendorCity();
            }
          }
        }
      });
    },
    getVendorCity() {
      this.cities = [];
      this.city_count = 0;
      if(!this.restaurant.state) return false;
      deliveryZoneService.getVendorCity({state_id: this.restaurant.state}).then((response) => {
        this.cities = response.data.result.sort((a, b) => {
          return a.cityname.localeCompare(b.cityname);
        });
        this.city_count = response.data.result.length;
        if (this.defaultcountry === this.restaurant.country && this.state_count > 0) {
          if (this.defaultstate === this.restaurant.state && this.city_count > 0) {
            this.restaurant.city = this.defaultcity;
          }
        }
        if (this.city_count == 1) {
          this.restaurant.city = this.cities[0].cityid;
        }
      });
    },
    getAllState() {
      deliveryZoneService.getAllState().then((response) => {
        // this.states = response.data.result;
        this.state_count = response.data.result.length;
        this.states = response.data.result.sort((a, b) => {
          return a.state_name.localeCompare(b.state_name);
        });
      });
    },
    getAllCity() {
      deliveryZoneService.getAllCity().then((response) => {
        // this.cities = response.data.result;
        this.city_count = response.data.result.length;
        this.cities = response.data.result.sort((a, b) => {
          return a.cityname.localeCompare(b.cityname);
        });
      });
    },
    vendorUpdate() {
      this.$v.restaurant.$touch();
      if (this.$v.restaurant.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 500, function() {
                $(".is-invalid:first").focus();
            });
        },500);
        return;
      } else {
        console.log('out');
        const fd = new FormData();
        fd.append("restaurant_id", this.restaurant.restaurant_id);
        fd.append("user_id", this.restaurant.user_id);
        fd.append("name", this.restaurant.name);
        fd.append("email", this.restaurant.email);
        fd.append("phone", this.restaurant.phone);
        fd.append("country", this.restaurant.country);
        fd.append("state", this.restaurant.state);
        fd.append("city", this.restaurant.city);
        fd.append("address", this.restaurant.address);
        fd.append("location_address", this.restaurant.location_address);
        fd.append("minimum_order_value", this.restaurant.minimum_order_value);
        fd.append("currency", this.restaurant.currency);
        fd.append("restaurant_tax", this.restaurant.restaurant_tax);
        fd.append("latitude", this.restaurant.latitude);
        fd.append("longitude", this.restaurant.longitude);
        fd.append("name_thai", this.restaurant.name_thai);
        fd.append("address_thai", this.restaurant.address_thai);
        fd.append("payment_option",this.restaurant.payment_option);
        fd.append("delivery_type_time_slots",this.restaurant.delivery_type_time_slots);
        if (!!this.restaurant.image) {
          fd.append("icon_image", this.restaurant.image);
        }
        vendorService.updateVendorInfo(fd).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            if (!this.$auth.partner_login) {
              this.$router.push({ name: "vendor-list" });
            }
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
    contactNumber(evt) {
      let val1 = evt.target.value;
      if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
        evt.preventDefault();
      }
      let partlen = val1.split("+").length - 1;
      if (evt.keyCode == 43 && partlen > 0) {
        evt.preventDefault();
      } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
        evt.preventDefault();
      }
    }
  },
};
</script>

<template>
  <div v-if="$auth.partner_login">
    <Layout>
      <PageHeader :title="title" />
      <div class="row">
        <div class="col-12">
          <form @submit.prevent="vendorUpdate">
            <!-- Vendor Info Start -->
            <div class="card">
              <div class="card-body">
                <h4
                  class="card-title"
                >{{ trans.trans('__JSON__.Vendor Info',{ vendor: $auth.setting.restaurant_name })}}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" v-if="$auth.setting">
                      <label>{{ trans.trans('__JSON__.Vendor Name',{ vendor: $auth.setting.restaurant_name , lang: $auth.langauges[0].name}) }}</label>
                      <input
                        id="name"
                        v-model="$v.restaurant.name.$model"
                        type="text"
                        class="form-control"
                        :placeholder="trans.trans('__JSON__.Enter Vendor Name langauge',{vendor: $auth.setting.restaurant_name , lang: $auth.langauges[0].name})"
                        name="name"
                        :class="{ 'is-invalid': $v.restaurant.name.$error }"
                      />
                      <div v-if="$v.restaurant.name.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.name.required"
                        >{{ trans.trans('__JSON__.Please enter vendor name',{ vendor: $auth.setting.restaurant_name })}}</span>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-sm-6 d-none"
                    v-if="$auth.langauges[1].name === 'No Secondary Language'"
                  ></div>
                  <div class="col-sm-6" v-else>
                    <div class="form-group">
                      <label>{{ trans.trans('__JSON__.Vendor Name',{vendor: $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[1].name }) }}</label>
                      <input
                        maxlength="100"
                        id="name_thai"
                        name="name_thai"
                        type="text"
                        v-model="$v.restaurant.name_thai.$model"
                        :placeholder="trans.trans('__JSON__.Enter Vendor Name langauge',{vendor: $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[1].name })"
                        class="form-control"
                        :class="{ 'is-invalid': $v.restaurant.name_thai.$error }"
                      />
                      <div v-if="$v.restaurant.name_thai.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.name_thai.required"
                        >{{ trans.trans('__JSON__.Please enter vendor name',{ vendor: $auth.setting.restaurant_name })}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>{{ trans.get('__JSON__.E-Mail') }}</label>
                      <input
                        id="email"
                        v-model="$v.restaurant.email.$model"
                        type="email"
                        name="email"
                        class="form-control"
                        @blur="userCheckEmail"
                        :class="{ 'is-invalid': $v.restaurant.email.$error }"
                        placeholder="Enter a valid e-mail"
                      />
                      <div v-if="$v.restaurant.email.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.email.required"
                        >{{ trans.get('__JSON__.Please enter email') }}</span>
                        <span
                          v-if="!$v.restaurant.email.email"
                        >{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>{{ trans.get('__JSON__.Contact Number') }}</label>
                      <input
                        maxlength="20"
                        minlength="6"
                        id="phone"
                        v-model="$v.restaurant.phone.$model"
                        type="text"
                        name="phone"
                        class="form-control"
                        :class="{ 'is-invalid': $v.restaurant.phone.$error }"
                        :placeholder="trans.get('__JSON__.Enter Contact Number')"
                        @keypress="contactNumber($event)"
                        @paste.prevent
                        autocomplete="nope"
                      />
                      <div v-if="$v.restaurant.phone.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.phone.required"
                        >{{ trans.get('__JSON__.Please enter contact number') }}</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <!-- Vendor Info End -->

            <!-- Location Section Start -->
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Location') }}</h4>
                <p class="card-title-desc"></p>

                <div class="row">
                  <div class="col-sm-6">
                    <div v-if="country_count >1" class="form-group">
                      <label class="control-label">{{ trans.get('__JSON__.Country') }}</label>
                      <select
                        class="custom-select"
                        v-model="$v.restaurant.country.$model"
                        @change="getVendorState"
                        id="country"
                        name="country"
                        :class="{ 'is-invalid': $v.restaurant.country.$error }"
                      >
                        <option value selected>{{ trans.get('__JSON__.Select Country') }}</option>
                        <option
                          v-for="con in countries"
                          :value="con.id"
                          :key="con.id"
                        >{{con.country_name}}</option>
                      </select>
                      <div v-if="$v.restaurant.country.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.country.required"
                        >{{ trans.get('__JSON__.Please select country') }}</span>
                      </div>
                    </div>

                    <div v-if="(country_count == 1 && state_count > 1) || country_count > 1" class="form-group">
                      <label class="control-label">{{ trans.get('__JSON__.State') }}</label>
                      <select
                        class="custom-select"
                        v-model="$v.restaurant.state.$model"
                        @change="getVendorCity"
                        id="state"
                        name="state"
                        :class="{ 'is-invalid': $v.restaurant.state.$error }"
                      >
                        <option value selected>{{ trans.get('__JSON__.Select State') }}</option>
                        <option
                          v-for="sat in states"
                          :value="sat.id"
                          :key="sat.id"
                        >{{sat.state_name}}</option>
                      </select>
                      <div v-if="$v.restaurant.state.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.state.required"
                        >{{ trans.get('__JSON__.Please select state')}}</span>
                      </div>
                    </div>

                    <div v-if="(country_count == 1 && state_count == 1 && city_count > 1) || country_count > 1 || state_count > 1" class="form-group">
                      <label class="control-label">{{ trans.get('__JSON__.City') }}</label>
                      <select
                        class="custom-select"
                        v-model="$v.restaurant.city.$model"
                        id="city"
                        name="city"
                        :class="{ 'is-invalid': $v.restaurant.city.$error }"
                      >
                        <option value selected>{{ trans.get('__JSON__.Select City') }}</option>
                        <option
                          v-for="cit in cities"
                          :value="cit.cityid"
                          :key="cit.cityid"
                        >{{cit.cityname}}</option>
                      </select>
                      <div v-if="$v.restaurant.city.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.city.required"
                        >{{ trans.get('__JSON__.Please select city') }}</span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label
                        class="control-label"
                      >{{ trans.get('__JSON__.Search Vendor Location On Google Map',{vendor: $auth.setting.restaurant_name}) }}</label>
                      <vue-google-autocomplete
                        ref="address"
                        id="address"
                        name="address"
                        type="text"
                        class="form-control"
                        :placeholder="trans.get('__JSON__.Search Vendor Location On Google Map',{vendor: $auth.setting.restaurant_name})"
                        v-model="$v.restaurant.address.$model"
                        v-on:placechanged="getAddressData"
                        :class="{'is-invalid':$v.restaurant.address.$error}"
                        types=""
                        :country="[$auth.setting.country_code_type]"
                      ></vue-google-autocomplete>

                      <div v-if="$v.restaurant.address.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.address.required"
                        >{{ trans.get('__JSON__.Please enter address') }}</span>
                      </div>
                    </div>

                    <div class="form-group">
                      <label
                        class="control-label"
                      >{{ trans.trans('__JSON__.Vendor Full address',{vendor: $auth.setting.restaurant_name} ) }}</label>
                      <input
                        id="location_address"
                        name="location_address"
                        type="text"
                        v-model="$v.restaurant.location_address.$model"
                        class="form-control"
                        :placeholder="trans.trans('__JSON__.Enter Vendor full address',{vendor: $auth.setting.restaurant_name})"
                        :class="{ 'is-invalid': $v.restaurant.location_address.$error }"
                      />
                      <div v-if="$v.restaurant.location_address.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.location_address.required"
                        >{{ trans.trans('__JSON__.Please enter Vendor full address',{vendor: $auth.setting.restaurant_name}) }}</span>
                      </div>
                    </div>

                    <div
                      v-if="$auth.langauges[1].name == 'No Secondary Language'"
                      class="form-group d-none"
                    ></div>
                    <div class="form-group" v-else>
                      <label
                        class="control-label"
                      >{{ trans.trans('__JSON__.Vendor Full address Secondary Language (Optional)', {vendor: $auth.setting.restaurant_name , lang: $auth.langauges[1].name }) }}</label>
                      <input
                        id="address_thai"
                        name="address_thai"
                        v-model="restaurant.address_thai"
                        type="text"
                        class="form-control"
                        :placeholder="trans.trans('__JSON__.Enter Vendor full address Secondary language', {vendor: $auth.setting.restaurant_name , lang: $auth.langauges[1].name })"
                        :class="{'is-invalid':$v.restaurant.address_thai.$error}"
                      />
                      <div v-if="$v.restaurant.address_thai.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.address_thai.required"
                        >{{ trans.get('__JSON__.Please enter address') }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="map1" id="map" style="height: 100%">
                      <!-- <gmap-map :center="center" :zoom="7" style="height: 300px">
                        <gmap-marker
                          v-for="(m, index) in markers"
                          :key="index"
                          :position="m.position"
                          :clickable="true"
                          :draggable="true"
                          @click="center = m.position"
                        ></gmap-marker>
                      </gmap-map>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Location Section End -->

            <!-- Other Info Start -->
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Other Info') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>{{ trans.get('__JSON__.Minimum Order Amount') }} ( {{ vendor_currency}} )</label>
                      <input
                        id="minimum_order_value"
                        name="minimum_order_value"
                        type="text"
                        v-model="$v.restaurant.minimum_order_value.$model"
                        class="form-control"
                        :placeholder="trans.get('__JSON__.Minimum Order Amount')"
                        :class="{ 'is-invalid':$v.restaurant.minimum_order_value.$error }"
                      />
                      <div v-if="$v.restaurant.minimum_order_value.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.restaurant.minimum_order_value.required"
                        >{{ trans.get('__JSON__.Please enter amount') }}</span>
                        <span
                          v-if="!$v.restaurant.minimum_order_value.floating"
                        >{{ trans.get('__JSON__.This value should be digits')}}.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-6" v-if="$auth.setting.is_pickup_enable == true">
                    <div class="form-group">
                      <label
                        class="control-label"
                      >{{ trans.get('__JSON__.Delivery Type & Time Slots') }}</label>
                      <select
                        class="custom-select"
                        v-model="restaurant.delivery_type_time_slots"
                        id="delivery_type_time_slots"
                        name="delivery_type_time_slots"
                      >
                        <option value>{{ trans.get('__JSON__.Select Delivery Type') }}</option>
                        <option v-bind:value="2" selected>{{ trans.get('__JSON__.Both') }}</option>
                        <option v-bind:value="1">{{ trans.get('__JSON__.Delivery') }}</option>
                        <option v-bind:value="0">{{ trans.get('__JSON__.Pickup') }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        class="control-label"
                      >{{ trans.get('__JSON__.GST',{gst: $auth.getTaxName()})}} (%)</label>
                      <input
                        id="restaurant_tax"
                        name="restaurant_tax"
                        type="text"
                        class="form-control"
                        :placeholder="trans.get('__JSON__.Vendor GST',{gst: $auth.getTaxName()})"
                        v-model="restaurant.restaurant_tax"
                        v-on:keypress="floatingNumber($event,restaurant.restaurant_tax)"
                      />
                    </div>
                  </div>

                  <div class="col-sm-6" v-if="$auth.setting && $auth.setting.restaurant_payment_option == 'Restaurant Select Payment Option'">
                    <div class="form-group">
                        <label>{{ trans.get('__JSON__.Payment Option') }}</label>
                        <select
                          class="custom-select"
                          v-model="restaurant.payment_option"
                          id="payment_option"
                          name="payment_option"
                        >
                          <option value="Both">{{ trans.get('__JSON__.Both') }}</option>
                          <option value="COD">{{ trans.get('__JSON__.Cash On Delivery') }}</option>
                          <option value="PAY ONLINE">{{ trans.get('__JSON__.PAY ONLINE') }}</option>
                        </select>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <!-- Other Info End -->

            <!-- Vendor Image Start -->
            <div class="card">
              <div class="card-body">
                <h4
                  class="card-title"
                >{{ trans.trans('__JSON__.Vendor Image',{ vendor: $auth.setting.restaurant_name }) }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">
                  <div class="col-sm-3 imgUp">
                    <dropzone-popup
                      v-model="restaurant.image"
                      id="icon_image"
                      acceptedFiles=".jpeg,.jpg,.png"
                      :editable-images="icon_image"
                      :media-path="restaurant_media_path+'/original'"
                      :delete-path="icon_image_delete_url"
                      :custom-params="{driverid: $route.params.driver_id}"
                      @image-deleted="this.onIconImagedeleted"
                      :class="{ 'is-invalid': $v.restaurant.image.$error }"
                    />
                    <div v-if="$v.restaurant.image.$error" class="invalid-feedback cuisine-img">
                      <span
                        v-if="!$v.restaurant.image.required"
                      >{{ trans.get('__JSON__.Please select image') }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <button
                      type="submit"
                      v-if="$auth.hasPermission(config.permissions.merchant_write)"
                      class="btn btn-primary mr-1 mt-3"
                      :disabled="disable"
                    >{{ trans.trans('__JSON__.Update Vendor',{ vendor: $auth.setting.restaurant_name }) }}</button>
                    <b-button
                      @click="$router.go(-1)"
                      type="button"
                      variant="secondary"
                      class="mt-3"
                    >{{ trans.get('__JSON__.Cancel') }}</b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Vendor Image End -->
          </form>
        </div>
      </div>
    </Layout>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-12">
        <form @submit.prevent="vendorUpdate" id="vendor-profile">
          <!-- Vendor Info Start -->
          <div class="card">
            <div class="card-body">
              <h4
                class="card-title"
              >{{ trans.trans('__JSON__.Vendor Info',{ vendor: $auth.setting.restaurant_name })}}</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group" v-if="$auth.setting">
                    <label>{{ trans.trans('__JSON__.Vendor Name',{ vendor: $auth.setting.restaurant_name , lang: $auth.langauges[0].name}) }}</label>
                    <input
                      id="name"
                      v-model="$v.restaurant.name.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Enter Vendor Name langauge',{vendor: $auth.setting.restaurant_name , lang: $auth.langauges[0].name})"
                      name="name"
                      :class="{ 'is-invalid': $v.restaurant.name.$error }"
                    />
                    <div v-if="$v.restaurant.name.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.name.required"
                      >{{ trans.trans('__JSON__.Please enter vendor name',{ vendor: $auth.setting.restaurant_name })}}</span>
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-6 d-none"
                  v-if="$auth.langauges[1].name === 'No Secondary Language'"
                ></div>
                <div class="col-sm-6" v-else>
                  <div class="form-group">
                    <label>{{ trans.trans('__JSON__.Vendor Name',{vendor: $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[1].name }) }}</label>
                    <input
                      maxlength="100"
                      id="name_thai"
                      name="name_thai"
                      type="text"
                      v-model="restaurant.name_thai"
                      :placeholder="trans.trans('__JSON__.Enter Vendor Name langauge',{vendor: $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[1].name })"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label>{{ trans.get('__JSON__.E-Mail') }}</label>
                    <input
                      id="email"
                      v-model="$v.restaurant.email.$model"
                      type="email"
                      name="email"
                      class="form-control"
                      @blur="userCheckEmail"
                      :class="{ 'is-invalid': $v.restaurant.email.$error }"
                      placeholder="Enter a valid e-mail"
                    />
                    <div v-if="$v.restaurant.email.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.email.required"
                      >{{ trans.get('__JSON__.Please enter email') }}</span>
                      <span
                        v-if="!$v.restaurant.email.email"
                      >{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label>{{ trans.get('__JSON__.Contact Number') }}</label>
                    <input
                      maxlength="20"
                      minlength="6"
                      id="phone"
                      v-model="$v.restaurant.phone.$model"
                      type="text"
                      name="phone"
                      class="form-control"
                      :class="{ 'is-invalid': $v.restaurant.phone.$error }"
                      :placeholder="trans.get('__JSON__.Enter Contact Number')"
                      @keypress="contactNumber($event)"
                      @paste.prevent
                      autocomplete="nope"
                    />
                    <div v-if="$v.restaurant.phone.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.phone.required"
                      >{{ trans.get('__JSON__.Please enter contact number') }}</span>
                      <!-- <span
                        v-if="!$v.restaurant.phone.numeric"
                      >{{ trans.get('__JSON__.This value should be a valid number') }}</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Vendor Info End -->

          <!-- Location Section Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ trans.get('__JSON__.Location') }}</h4>
              <p class="card-title-desc"></p>

              <div class="row">
                <div class="col-sm-6">
                  <div v-if="country_count >1" class="form-group">
                    <label class="control-label">{{ trans.get('__JSON__.Country') }}</label>
                    <select
                      class="custom-select"
                      v-model="$v.restaurant.country.$model"
                      @change="getVendorState"
                      id="country"
                      name="country"
                      :class="{ 'is-invalid': $v.restaurant.country.$error }"
                    >
                      <option value selected>{{ trans.get('__JSON__.Select Country') }}</option>
                      <option
                        v-for="con in countries"
                        :value="con.id"
                        :key="con.id"
                      >{{con.country_name}}</option>
                    </select>
                    <div v-if="$v.restaurant.country.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.country.required"
                      >{{ trans.get('__JSON__.Please select country') }}</span>
                    </div>
                  </div>

                  <div v-if="(country_count == 1 && state_count > 1) || country_count > 1" class="form-group">
                    <label class="control-label">{{ trans.get('__JSON__.State') }}</label>
                    <select
                      class="custom-select"
                      v-model="$v.restaurant.state.$model"
                      @change="getVendorCity"
                      id="state"
                      name="state"
                      :class="{ 'is-invalid': $v.restaurant.state.$error }"
                    >
                      <option value selected>{{ trans.get('__JSON__.Select State') }}</option>
                      <option v-for="sat in states" :value="sat.id" :key="sat.id">{{sat.state_name}}</option>
                    </select>
                    <div v-if="$v.restaurant.state.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.state.required"
                      >{{ trans.get('__JSON__.Please select state')}}</span>
                    </div>
                  </div>

                  <div v-if="(country_count == 1 && state_count == 1 && city_count > 1) || country_count > 1 || state_count > 1" class="form-group">
                    <label class="control-label">{{ trans.get('__JSON__.City') }}</label>
                    <select
                      class="custom-select"
                      v-model="$v.restaurant.city.$model"
                      id="city"
                      name="city"
                      :class="{ 'is-invalid': $v.restaurant.city.$error }"
                    >
                      <option value selected>{{ trans.get('__JSON__.Select City') }}</option>
                      <option
                        v-for="cit in cities"
                        :value="cit.cityid"
                        :key="cit.cityid"
                      >{{cit.cityname}}</option>
                    </select>
                    <div v-if="$v.restaurant.city.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.city.required"
                      >{{ trans.get('__JSON__.Please select city') }}</span>
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      class="control-label"
                    >{{ trans.get('__JSON__.Search Vendor Location On Google Map',{vendor: $auth.setting.restaurant_name}) }}</label>
                    <vue-google-autocomplete
                      ref="address"
                      id="address"
                      name="address"
                      type="text"
                      class="form-control"
                      :placeholder="trans.get('__JSON__.Search Vendor Location On Google Map',{vendor: $auth.setting.restaurant_name})"
                      v-model="$v.restaurant.address.$model"
                      v-on:placechanged="getAddressData"
                      :class="{'is-invalid':$v.restaurant.address.$error}"
                      types=""
                      :country="[$auth.setting.country_code_type]"
                    ></vue-google-autocomplete>

                    <div v-if="$v.restaurant.address.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.address.required"
                      >{{ trans.get('__JSON__.Please enter address') }}</span>
                    </div>
                  </div>

                  <div class="form-group">
                    <label
                      class="control-label"
                    >{{ trans.trans('__JSON__.Vendor Full address',{vendor: $auth.setting.restaurant_name} ) }}</label>
                    <input
                      id="location_address"
                      name="location_address"
                      type="text"
                      v-model="$v.restaurant.location_address.$model"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Enter Vendor full address',{vendor: $auth.setting.restaurant_name})"
                      :class="{ 'is-invalid': $v.restaurant.location_address.$error }"
                    />
                    <div v-if="$v.restaurant.location_address.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.location_address.required"
                      >{{ trans.trans('__JSON__.Please enter Vendor full address',{vendor: $auth.setting.restaurant_name}) }}</span>
                    </div>
                  </div>

                  <div
                    v-if="$auth.langauges[1].name == 'No Secondary Language'"
                    class="form-group d-none"
                  ></div>
                  <div class="form-group" v-else>
                    <label
                      class="control-label"
                    >{{ trans.trans('__JSON__.Vendor Full address Secondary Language (Optional)', {vendor: $auth.setting.restaurant_name , lang: $auth.langauges[1].name }) }}</label>
                    <input
                      id="address_thai"
                      name="address_thai"
                      v-model="restaurant.address_thai"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Enter Vendor full address Secondary language', {vendor: $auth.setting.restaurant_name , lang: $auth.langauges[1].name })"
                    />
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="map1" id="map" style="height: 100%">
                    <!-- <gmap-map :center="center" :zoom="7" style="height: 300px">
                      <gmap-marker
                        v-for="(m, index) in markers"
                        :key="index"
                        :position="m.position"
                        :clickable="true"
                        :draggable="true"
                        @click="center = m.position"
                      ></gmap-marker>
                    </gmap-map>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Location Section End -->

          <!-- Other Info Start -->
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ trans.get('__JSON__.Other Info') }}</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>{{ trans.get('__JSON__.Minimum Order Amount') }} ( {{ vendor_currency}} )</label>
                    <input
                      id="minimum_order_value"
                      name="minimum_order_value"
                      type="text"
                      v-model="$v.restaurant.minimum_order_value.$model"
                      class="form-control"
                      :placeholder="trans.get('__JSON__.Minimum Order Amount')"
                      :class="{ 'is-invalid':$v.restaurant.minimum_order_value.$error }"
                    />
                    <div v-if="$v.restaurant.minimum_order_value.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.restaurant.minimum_order_value.required"
                      >{{ trans.get('__JSON__.Please enter amount') }}</span>
                      <span
                        v-if="!$v.restaurant.minimum_order_value.floating"
                      >{{ trans.get('__JSON__.This value should be digits')}}.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6" v-if="$auth.setting.is_pickup_enable == true">
                  <div class="form-group">
                    <label
                      class="control-label"
                    >{{ trans.get('__JSON__.Delivery Type & Time Slots') }}</label>
                    <select
                      class="custom-select"
                      v-model="restaurant.delivery_type_time_slots"
                      id="delivery_type_time_slots"
                      name="delivery_type_time_slots"
                    >
                      <option value>{{ trans.get('__JSON__.Select Delivery Type') }}</option>
                      <option v-bind:value="2" selected>{{ trans.get('__JSON__.Both') }}</option>
                      <option v-bind:value="1">{{ trans.get('__JSON__.Delivery') }}</option>
                      <option v-bind:value="0">{{ trans.get('__JSON__.Pickup') }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      class="control-label"
                    >{{ trans.get('__JSON__.GST',{gst: $auth.getTaxName()})}} (%)</label>
                    <input
                      id="restaurant_tax"
                      name="restaurant_tax"
                      type="text"
                      class="form-control"
                      :placeholder="trans.get('__JSON__.Vendor GST',{gst: $auth.getTaxName()})"
                      v-model="restaurant.restaurant_tax"
                      v-on:keypress="floatingNumber($event,restaurant.restaurant_tax)"
                    />
                  </div>
                </div>

                <div class="col-sm-6" v-if="$auth.setting && $auth.setting.restaurant_payment_option == 'Restaurant Select Payment Option'">
                  <div class="form-group">
                    <label>{{ trans.get('__JSON__.Payment Option') }}</label>
                      <select
                        class="custom-select"
                        v-model="restaurant.payment_option"
                        id="payment_option"
                        name="payment_option"
                      >
                      <option value="Both">{{ trans.get('__JSON__.Both') }}</option>
                      <option value="COD">{{ trans.get('__JSON__.Cash On Delivery') }}</option>
                      <option value="PAY ONLINE">{{ trans.get('__JSON__.PAY ONLINE') }}</option>
                    </select>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <!-- Other Info End -->

          <!-- Vendor Image Start -->
          <div class="card">
            <div class="card-body">
              <h4
                class="card-title"
              >{{ trans.trans('__JSON__.Vendor Image',{ vendor: $auth.setting.restaurant_name }) }}</h4>
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-3 imgUp">
                  <dropzone-popup
                    v-model="restaurant.image"
                    id="icon_image"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :editable-images="icon_image"
                    :media-path="restaurant_media_path+'/original'"
                    :delete-path="icon_image_delete_url"
                    :custom-params="{driverid: $route.params.driver_id}"
                    @image-deleted="this.onIconImagedeleted"
                    :class="{ 'is-invalid': $v.restaurant.image.$error }"
                  />
                  <div v-if="$v.restaurant.image.$error" class="invalid-feedback cuisine-img">
                    <span
                      v-if="!$v.restaurant.image.required"
                    >{{ trans.get('__JSON__.Please select image') }}</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <button
                    type="submit"
                    v-if="$auth.hasPermission(config.permissions.merchant_write)"
                    class="btn btn-primary mr-1 mt-3"
                    :disabled="disable"
                  >{{ trans.trans('__JSON__.Update Vendor',{ vendor: $auth.setting.restaurant_name }) }}</button>
                  <!-- <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                  >{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                  <router-link
                    :to="{name:'vendor-list'}"
                  >
                    <b-button
                      type="button"
                      variant="secondary"
                      class="mt-3"
                    >{{ trans.get('__JSON__.Cancel') }}</b-button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- Vendor Image End -->
        </form>
      </div>
    </div>
  </div>
  <!-- end row -->
</template>
